"use strict";

export const pageBaner = class {
  mainContainer = false;
  elements = [];
  curentElement = 0;
  animationTime = 500;
  delayTime = 6000;
  animationInClassName = "page-baner__slide--show";
  animationOutClassName = "page-baner__slide--hide";

  constructor(container) {
    if (!container) {
      return false;
    }
    this.mainContainer = container;
    this.elements = Array.from(this.mainContainer.children);

    if (this.elements.length == 0) return false;

    this._start();
    return this;
  }

  _start = () => {
    const { _setBackgroundImage, _startSlideShow } = this;

    _setBackgroundImage();
    _startSlideShow();
  };

  _startSlideShow = () => {
    const {
      elements,
      curentElement,
      animationInClassName,
      _setIntervalSlideShow,
    } = this;

    elements[curentElement].classList.add(animationInClassName);
    if (this.elements.length < 2) return false;
    _setIntervalSlideShow();
  };

  _setIntervalSlideShow = () => {
    const {
      elements,
      curentElement,
      animationTime,
      delayTime,
      animationInClassName,
      animationOutClassName,
    } = this;

    let next = curentElement + 1;
    if (next >= elements.length) {
      next = 0;
    }

    elements[next].classList.add(animationInClassName);
    elements[curentElement].classList.remove(animationInClassName);
    elements[curentElement].classList.add(animationOutClassName);

    let prevElement = this.curentElement;
    this.curentElement = next;

    setTimeout(() => {
      elements[prevElement].classList.remove(animationOutClassName);
    }, animationTime);

    setTimeout(() => {
      this._setIntervalSlideShow();
    }, delayTime);
  };

  _setBackgroundImage = () => {
    const { elements } = this;

    elements.forEach((element) => {
      const src = element.getAttribute("data-src");
      element.style.backgroundImage = `url(${src})`;
    });
  };
};
